
export function initCampChannelRouter(router) {
  // 判断是否为营地频道
  router.beforeEach((to, from, next) => {
    if (to.query && to.query.scene && to.query.scene === 'YD') {
      sessionStorage.setItem('key_scene', to.query.scene);
      next();
    } else {
      next();
    }
  });
}
export function isCampChannel() {
  if (sessionStorage.getItem('key_scene') === 'YD') {
    return true;
  }
  return false;
}


